import { Component } from 'preact';
import './style';
import smoothscroll from 'smoothscroll-polyfill';
import Main from 'layouts/main';
import Intro from 'components/Intro';
import HowWeMeet from 'components/HowWeMeet';
import RomanceBreakdownViz from 'components/RomanceBreakdownViz';
import BreakupMosaic from 'components/BreakupMosaic';
import RelatedContent from 'components/RelatedContent';
import SVGs from 'components/SVGs';
import sections from 'data/sections';
import data from 'data/data';

if (typeof window !== 'undefined') {
	smoothscroll.polyfill();

	if (
		!('IntersectionObserver' in window) &&
		!('IntersectionObserverEntry' in window) &&
		!(
			window.IntersectionObserverEntry &&
			'intersectionRatio' in window.IntersectionObserverEntry.prototype
		)
	) {
		require('intersection-observer');
	}

	window.onbeforeunload = function() {
		window.scrollTo(0, 0);
	};
}

if (module.hot) {
	require('preact/debug');
}

class Site extends Component {
	lazyLoad() {
		this.setState({ hasScrolled: true });
	}

	constructor(props) {
		super(props);

		this.state = { hasScrolled: false };
		this.lazyLoad = this.lazyLoad.bind(this);
	}

	render() {
		const { hasScrolled } = this.state;

		return (
			<Main>
				<SVGs />
				<Intro />
				<HowWeMeet inViewCallback={this.lazyLoad} />
				<RomanceBreakdownViz
					sections={sections}
					data={data}
					loaded={hasScrolled}
				/>
				<BreakupMosaic />
				<RelatedContent loaded={hasScrolled} />
			</Main>
		);
	}
}

export default Site;



// WEBPACK FOOTER //
// ./index.js